import { localize } from '@/utils/i18n.js'

export const text = {
    recuter_email: localize({
        ru: 'Почта рекрутера',
        en: 'Recruiter email'
    }),
    recuter_phone: localize({
        ru: 'Номер телефона рекрутера',
        en: 'Recruiter phone'
    }),
    money: localize({
        ru: 'Зарплата',
        en: 'Salary'
    }),
    linkText: localize({
        ru: 'Вернутся к списку вакансий',
        en: 'Back to list'
    }),
    filters: {
        city: localize({
            ru: 'Город',
            en: 'City'
        }),
        title: localize({
            ru: 'Название',
            en: 'Title'
        }),
        specialization: localize({
            ru: 'Специализация',
            en: 'Specialization'
        }),
        jobType: localize({
            ru: 'Тип вакансии',
            en: 'Job type'
        }),
        reset: localize({
            ru: 'Сбросить',
            en: 'Reset'
        })
    },
    count: localize({
        ru: 'Всего:',
        en: 'Total:'
    }),
    notFound: {
        title: localize({
            ru: 'По вашему запросу ничего не найдено',
            en: 'Nothing found for your request'
        }),
        text: localize({
            ru: 'Попробуйте изменить параметры поиска',
            en: 'Try changing your search options'
        })
    }
}
